import React, { useState } from "react";
import PropTypes from "prop-types";

const CORRECT_PASSWORD = "IB2026!";

export default function LoginPage({ onLogin }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [shake, setShake] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === CORRECT_PASSWORD) {
      sessionStorage.setItem("po_auth", "1");
      onLogin();
    } else {
      setError(true);
      setShake(true);
      setPassword("");
      setTimeout(() => setShake(false), 600);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="w-full max-w-sm px-8 py-10 bg-slate-800 rounded-2xl shadow-2xl border border-slate-700">
        <div className="flex flex-col items-center mb-8">
          <div className="w-12 h-12 rounded-xl bg-[#00C26D] flex items-center justify-center mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 11c0-1.657-1.343-3-3-3S6 9.343 6 11v1H4v8h16v-8h-2v-1c0-1.657-1.343-3-3-3s-3 1.343-3 3v1H9v-1z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2" />
            </svg>
          </div>
          <h1 className="text-xl font-semibold text-white">IT Command Center</h1>
          <p className="text-slate-400 text-sm mt-1">Enter your password to continue</p>
        </div>

        <form onSubmit={handleSubmit} className={shake ? "animate-[shake_0.5s_ease-in-out]" : ""}>
          <div className="mb-4">
            <input
              type="password"
              value={password}
              onChange={(e) => { setPassword(e.target.value); setError(false); }}
              placeholder="Password"
              autoFocus
              className={`w-full px-4 py-3 rounded-lg bg-slate-700 text-white placeholder-slate-400 border focus:outline-none focus:ring-2 transition-colors ${
                error
                  ? "border-red-500 focus:ring-red-500"
                  : "border-slate-600 focus:ring-[#00C26D] focus:border-[#00C26D]"
              }`}
            />
            {error && (
              <p className="mt-2 text-sm text-red-400">Incorrect password. Please try again.</p>
            )}
          </div>

          <button
            type="submit"
            className="w-full py-3 rounded-lg bg-[#00C26D] hover:bg-[#00D97E] text-white font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#00C26D] focus:ring-offset-2 focus:ring-offset-slate-800"
          >
            Sign In
          </button>
        </form>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          15%       { transform: translateX(-6px); }
          30%       { transform: translateX(6px); }
          45%       { transform: translateX(-4px); }
          60%       { transform: translateX(4px); }
          75%       { transform: translateX(-2px); }
          90%       { transform: translateX(2px); }
        }
      `}</style>
    </div>
  );
}

LoginPage.propTypes = {
  onLogin: PropTypes.func.isRequired,
};
